import BackButton from 'components/buttons/BackButton';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {Link} from 'react-router-dom';
import Route from 'routes/Routes';
import {FormattedMessage} from 'react-intl';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    flexDirection: 'column'
  },
  back: {
    '@media (max-width: 959px)': {
      textAlign: 'right'
    },
  },
  title: {
    marginTop: 30,
  },
}), {name: 'BuildingPageHeader'});

const BuildingPageHeader = () : JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container className={classes.header}>
      <Grid className={classes.back} item xs={12}>
        <BackButton component={Link} to={Route.ADMIN} />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.title} color="textPrimary" variant="h2">
          <FormattedMessage id="building_page.title" />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default BuildingPageHeader;